<!-- splash screen -->
<div #splashScreen class="m-splash-screen">
	<img [attr.src]="splashScreenImage" style="width: 90px; margin-bottom: 30px;" alt="Logo">
	<!--here we will have circle progress bar-->
	<mat-spinner diameter="40"></mat-spinner>
</div>


<!-- <mat-icon svgIcon="money"></mat-icon> -->

<div *ngIf="showAlert" class="m-alert-screen">
		<m-alert type="accent" (close)="showAlert = false">
	  {{ alertMessage }}
	</m-alert>
  </div>
<angular-progress-spinner></angular-progress-spinner>
<router-outlet></router-outlet>
